import { actions } from '@/translations/pl/flow/actions'
import { actionStage } from '@/translations/pl/flow/actionStage'
import { command } from '@/translations/pl/flow/command'
import { controls } from '@/translations/pl/flow/controls'
import { errors } from '@/translations/pl/flow/errors'
import { form } from '@/translations/pl/flow/form'
import { labels } from '@/translations/pl/flow/labels'
import { manage } from '@/translations/pl/flow/manage'
import { manageIndexes } from '@/translations/pl/flow/manageIndexes'
import { matrix } from '@/translations/pl/flow/matrix'
import { modals } from '@/translations/pl/flow/modals'
import { options } from '@/translations/pl/flow/options'
import { packages } from '@/translations/pl/flow/packages'
import { properties } from '@/translations/pl/flow/properties'
import { rules } from '@/translations/pl/flow/rules'
import { signatures } from '@/translations/pl/flow/signatures'
import { status } from '@/translations/pl/flow/status'
import { table } from '@/translations/pl/flow/table'
import { tabs } from '@/translations/pl/flow/tabs'

export const flow = {
  selectOptions: 'Opcja',
  addNewNode: 'Dodaj nowy blok szablonu konfiguracji',
  addNewNodePara:
    'Dodaj nowy krok (węzeł) do edytora szablonu konfiguracji. Węzeł jest podstawową jednostką szablonu konfiguracji, w której możesz definiować opcje, reguły i zależności.',
  label: 'Etykieta',
  edit: 'Edytuj',
  displayEdit: 'Podgląd formularza',
  code: 'Kod',
  description: 'Opis opcji',
  integrationCode: 'Kod integracji',
  startAt: 'Ważny od',
  expiresAt: 'Ważny do',
  calendarPlaceholder: 'Wybierz zakres dat',
  startAtPlaceholder: 'Ważny od (YYYY-MM-DD)',
  expiresAtPlaceholder: 'Ważny do (YYYY-MM-DD)',
  manageStep: 'Zarządzanie etapami',
  addNewStep: 'Dodaj nowy etap',
  assignStep: 'Przypisz etap do obecnego kroku',
  currentStageMissing: 'Krok nie jest jeszcze przypisany do etapu',
  changeStage: 'Zmień etap',
  assignStepDesc:
    'Wybierz etap, do którego ma należeć ten krok. Po przypisaniu panel pokaże więcej akcji.',
  addNewStepDesc:
    'Utwórz nowy etap dla obecnego szablonu konfiguracji i wróć do przypisania kroków.',

  deleteStep: 'Usuń krok',
  deleteStepDesc:
    'Usunięcie tego kroku permanentnie usunie wszystkie zależności i zdejmie go z widoku. Ta akcja nie może być cofnięta.',
  deleteStepTitle: 'Czy jesteś pewien?',
  deleteStepWarning:
    'Ta akcja jest nieodrwacalna. Po wykonaniu krok zostanie usunięty.',
  save: 'Zapisz',
  noOptions: 'Brak opcji',
  addOption: 'Dodaj opcję',
  deleteOption: 'Usuń opcję',
  deletedOptionSuccess: 'Pomyślnie usunięto opcję',
  groups: 'Grupy',
  groupsPreview: 'Podejrzyj możliwe powiązania',
  groupsNotAvailable:
    'Brak dostępnych grup. Stwórz nową grupę aby móc ją przypisać.',
  groupAdd: 'Dodaj grupę',
  cancel: 'Anuluj',
  publishConfirm: 'Czy na pewno chcesz opublikować ten szablon konfiguracji?',
  publishDesc:
    'Opublikowanie sprawi, że szablon konfiguracji będzie widoczny na połączonej stronie.',
  publishDescription: 'Opublikuj ten szablon konfiguracji.',
  publishDisabledDescription:
    'Początkowa konfiguracja nie może zawierać konfliktów. Sprawdź skonfigurowane opcje i reguły przed publikacją.',
  publishSuccess: 'Szablon konfiguracji opublikowany pomyślnie',
  removeConnection: 'Usunięto połączenie',
  statusTitle: 'Status',
  productIndex: 'Indeks produktu',
  signatureElement: 'Sygnatura produktu',
  inputType: 'Rodzaj opcji',
  integrationParameterUsed: 'Ten parametr integracji jest już używany.',
  integrationParameterFilterUsed: 'Użyte',
  integrationParameterFilterUnused: 'Nieużyte',
  integrationParameterAllowedTypes: 'Dozwolone typy',
  integrationParameterValues: 'Wartości',
  integrationParameterNoValues: 'Brak wartości',
  integrationValue: 'Wartość integracji',
  selectValue: 'Wybierz wartość',
  noIntegrationParameters: 'Nie znaleziono parametrów integracji.',
  refreshIntegrationParameters: 'Odśwież cechy Impuls',
  refreshIntegrationParametersTooltip:
    'Pobierz najnowsze cechy Impuls z systemu.',
  integrationStatusNotIntegrated: 'Krok nie ma przypisanego kodu integracji.',
  integrationStatusUnknownCode:
    'Nieznany kod integracji - mógł ulec zmianie w Impuls.',
  indexSuccess: 'Indeks zaktualizowany pomyślnie',
  stepLabel: 'Krok',
  optionLabel: 'Opcja',
  editIndex: 'Edytuj indeks produktu',
  manageIndexesDesc: 'Zarządaj i edytuj indeksami',
  editFormOpts: 'Edytuj opcje formularza',
  displayFormOpts: 'Podgląd opcji formularza',
  exampleFor: 'Przykład dla',
  treePropertySave: 'Zapisz widoczność właściwości',
  treeRestoreProperties: 'Przywróć domyślną widoczność',
  componentStep: 'Krok składowy',
  confirmComponentTitle: 'Zmieniono krok zależny',
  confirmComponent:
    'Zmiania opcji kroku zaleznego usunie wszystkie istniejące połączenia. Czy chcesz kontynuować?',
  confirmChangeComponentTitle: 'Potwierdź zmianę kroku składowego',
  confirmChangeComponentDescription:
    'Zmiana tego ustawienia może wpłynąć na istniejące połączenia. Czy chcesz kontynuować?',
  signatureSegment: 'Sygnatura',
  requiresSignatureSegment: 'Czy wymaga sygnatury segmentu?',
  confirmDeleteSignatureFromOptionsTitle: 'Zmiana wymagania sygnatury',
  confirmDeleteSignatureFromOptions:
    'Zmiana spowoduje usunięcie sygnatur z wszystkich opcji, które mają to przypisane',
  confirmDeleteOptionsOnInputTypeChangeTitle: 'Zmiana typu wejścia',
  confirmDeleteOptionsOnInputTypeChange:
    'Ta zmiana usunie wszystkie istniejące opcje tego kroku. Czy chcesz kontynuować?',
  chooseIndexes: 'Wybierz indeksy produktów',
  indexSelected: 'Indeks wybrany {index}',
  indexDetails: 'Szczegóły indeksu',
  indexIdentif: 'Identyfikator indeksu',
  closeDatils: 'Zamknij szczegóły',
  chooseIndex: 'Wybierz ten indeks',
  showDetails: 'Pokaż detaile',
  expandAll: 'Rozwiń wszystkie',
  expandOneDeep: 'Rozwiń o jeden poziom',
  breadcrumbsTitle: 'Szablon konfiguracji',
  breadcrumbsDesc: 'Dane obecnego szablonu konfiguracji',
  duplicate: 'Kopiuj',
  allFlowsCount: 'Łącznie: {count} szablonów konfiguracji',
  flowsCount: '{count} szablonów konfiguracji',
  example: {
    podwozieWielkie: 'Podwozie wielkie',
    podwozieMale: 'Podwozie male',
    listwaZabezpieczajaca: 'Listwa zabezpieczająca',
    kontener: 'Kontener',
    uchwyty: 'Uchwyty mocujące',
    color1: 'Zielony',
    color2: 'Niebieski',
  },
  notifications: {
    nodeDeleted: 'Pomyślnie usunięto krok',
  },
  index: 'Indeks',
  status: status,
  options: options,
  packages: packages,
  tabs: tabs,
  command: command,
  actions: actions,
  form: form,
  errors: errors,
  modals: modals,
  table: table,
  actionStage: actionStage,
  manageIndexes: manageIndexes,
  rules: rules,
  matrix: matrix,
  manage: manage,
  properties: properties,
  signatures: signatures,
  controls: controls,
  labels: labels,
}
